<div class="dashboard-container">

  <div class="stats-section">
    <div class="stat-card border" *ngFor="let stat of stats">
      <div class="stat-icon">
        <i class="bi bi-{{stat.icon}}"></i>
      </div>
      <div class="stat-content">
        <h3 class="text-danger">{{stat.value}}</h3>
        <p>{{stat.title}}</p>
      </div>
    </div>
  </div>

  <div class="links-section">
    <div class="section-header">
      <h2 class="section-title">My Affiliate Links</h2>
    </div>
    <div class="links-grid">
      <div *ngFor="let product of affiliateLinks" class="product-card border">
      <div class="link-card">
        <div class="link-header">
          <div class="link-product">
            <div class="product-icon">
              <i class="fas fa-laptop"></i>
            </div>
            <div class="product-details">
              <div class="product-name">{{product.title}}</div>
              <div class="product-category">{{product.brand}}</div>
            </div>
          </div>
          <div class="link-type">{{product.detail.status}}</div>
        </div>

        <div class="link-url">
            <div class="link-text">
              https://www.smartdukaan.com/product/{{product.catalogId}}?smartCode={{smartCode}}
            </div>
            <button class="copy-btn" (click)="copyToClipboard('https://www.smartdukaan.com/product/' + product.catalogId + '?smartCode=' + smartCode)">
              Copy
            </button>
          </div>


        <div class="link-footer">
          <div class="link-meta">
            <div class="meta-item">
              <div class="meta-label">Created</div>
              <div class="meta-value">{{product.detail.createdAt | date}}</div>
            </div>
            <div class="meta-item">
              <div class="meta-label">Price</div>
              <div class="meta-value">{{product.mop| number:'1.2-2'}}</div>
            </div>
          </div>
          <div class="link-actions">
            <button class="action-btn">
              <i class="fas fa-chart-line"></i>
            </button>
            <button class="action-btn">
              <i class="fas fa-share-alt"></i>
            </button>
          </div>
        </div>
      </div>
      </div>


      <div class="empty-state" *ngIf="affiliateLinks.length==0">
          <div class="empty-icon">
              <i class="fas fa-link-slash"></i>
          </div>
          <div class="empty-title">No Affiliate Links Found</div>
          <div class="empty-text">You haven't generated any affiliate links yet. Start promoting products to earn commissions!</div>
          <button class="generate-btn">Generate Your First Link</button>
      </div>
    </div>
  </div>

</div>


